<template>
  <div class="sky-input">
    <itemSearch v-bind="$attrs">
      <el-input
        :type="inputType"
        :value="selfData"
        @change="change"
        @input="input"
        v-bind="$attrs"
        ref="input"
        :placeholder="placeholder"
        show-password
      ></el-input>
      <el-button
        class="venify-btn"
        type="primary"
        @click="scope.venifyEmail(selfData)"
      >验证邮箱</el-button>
    </itemSearch>
  </div>
</template>
<script>
// import itemSearch from "@/components/iglobalwin/formComponents/SkySuffix.vue";
import formStore from "@/mixins/formStore.js";
export default {
  name: "sky-venify",
  props: {
    toolContent: String,
    placeholder: "",
    inputType: {
      type: String,
      default: "text"
    },
    scope: {
      type: Object
    }
  },
  mixins: [formStore],
  data() {
    return {
      selfData: ""
    };
  },
  methods: {
    change(val) {
      this.selfData = val;
      !this.delay && this.setVal();
      this.scope.change && this.scope.change(val);
    },
    input(val) {
      this.selfData = val
    }
  }
};
</script>
<style scoped lang="scss">
.venify-btn {
  margin-left: 20px;
}
</style>
